import interceptorAxios from './InterceptorAxios';
const ServicioMetodoPago = {
    paginacion(objeto){
        return interceptorAxios.post('metodo_pago/paginacion.json',objeto);
    },
    guardar(objeto){
        return interceptorAxios.post('metodo_pago/guardar.json',objeto);
    },
    eliminar(objeto){
        return interceptorAxios.post('metodo_pago/eliminar.json',objeto);
    },
    buscarLike(objeto){
        return interceptorAxios.post('metodo_pago/buscar_like.json',objeto);
    }
   
}
export default ServicioMetodoPago;